import { useState, useEffect } from 'react';
import { ReactEditor } from 'slate-react'
import { withData } from '../DataController';



const TableOfContentsLine = (props) => {
    const { editor, element, passedTocNode, gapStyle } = props
    const styles = props.styles;
    const flowStyles = props.flowStyles;
    const tocStyle = styles[flowStyles['tableOfContent']];
    const tocStyleMerged = tocStyle ? props.data.getStyle(tocStyle, true) : {};
    const [indent, setIndent] = useState(0)

    useEffect(() => {
        if (passedTocNode) {
            const theLevel = passedTocNode?.levels?.find(l => element.heading === 'heading-one' ? l.type === 'h1' : element.heading === 'heading-two' ? l.type === 'h2' : element.heading === 'heading-three' ? l.type === 'h3' : null)
            if (theLevel) setIndent(theLevel.indent)
        }
    }, [passedTocNode])


    function scrollToNode(event) {
        event.preventDefault();
        const orginalHeading = editor.children[element?.headingIndex]
        if (orginalHeading.id === element.headingId) {
            const domNode = ReactEditor.toDOMNode(editor, orginalHeading);
            domNode.scrollIntoView({ behavior: 'smooth' });
        }
    }


    return (
        <p
            key={"heading-in-toc-" + 0}
            className='toc-label-container'
            contentEditable={false}
            style={{ display: "flex", flexWrap: 'wrap', alignItems: "baseline", marginLeft: indent + "pt", marginBottom: tocStyleMerged?.paddingBelowParagraph }}
        >
            <span onClick={(e) => scrollToNode(e)} style={{ ...tocStyleMerged, cursor: 'pointer', width: "fit-content" }}>
                {element.children[0].text}
            </span>
            <span style={{ width: 'auto', display: 'flex', flexGrow: 1, alignItems: 'baseline' }}>
                <span style={{ borderBottom: `1px ${gapStyle === 'dotted' ? 'dotted' : 'solid'} ${gapStyle === 'transparent' ? 'transparent' : styles[flowStyles['p']].color}`, flexGrow: '1', marginLeft: '3pt', marginRight: '3pt' }} />
                <span className='slate-toc-number' style={{ ...tocStyleMerged }} >
                    {element?.page}
                </span>
            </span>
        </p>
    )
}

export default withData(TableOfContentsLine);